<template>
  <Section
    v-bind="$attrs"
    title="Activity Types"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    icon="event"
    :isLoading="isLoading"
    @onShouldSearch="(val) => (searchText = val)"
  >
    <v-data-table
      :headers="headers"
      :items="activityTypeList"
      :search="searchText"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">
          <v-icon :color="props.item.isStatusChange ? 'green' : 'red'">{{
            props.item.isStatusChange ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-left">
          <v-icon :color="props.item.isLocationChange ? 'green' : 'red'">{{
            props.item.isLocationChange ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-left">
          <v-chip
            v-for="assetStatusId in props.item.assetStatusIds"
            :key="assetStatusId"
            :disabled="isLoading"
          >
            {{
              "" +
              _entityPropertyValueByName({
                entityList: assetStatusList,
                idKey: "id",
                idValue: assetStatusId,
                propertyKey: "name",
              })
            }}
          </v-chip>
        </td>
        <!-- <td class="text-xs-left">
          <v-icon>{{ props.item.isUpcoming ? 'done' : 'close' }}</v-icon>
        </td> -->
        <td class="text-xs-left">
          <v-icon :color="props.item.isEnabled ? 'green' : 'red'">{{
            props.item.isEnabled ? "done" : "close"
          }}</v-icon>
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="Edit"
            icon="edit"
            iconColor="warning"
            :disabled="isLoading"
            @onClicked="
              $emit('onEditActivityTypeClicked', {
                activityTypeToEdit: props.item,
              })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  mixins: [mixinAssetHelper],
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    searchText: null,
    headers: [
      { text: 'Name', value: 'name', align: 'left', sortable: false },
      {
        text: 'Status Change',
        value: 'isStatusChange',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Location Change',
        value: 'isLocationChange',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Equipment Statuses',
        value: 'assetStatusId',
        align: 'left',
        sortable: false,
      },
      // { text: 'Is Upcoming', value: 'isUpcoming', align: 'left' },
      { text: 'Enabled', value: 'isEnabled', align: 'left', sortable: false },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
